import BaseIcon from '@material-ui/icons/ReportOutlined';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
});

export default withStyles(styles)(BaseIcon);
